import { render } from "./BlListField.vue?vue&type=template&id=f112885a"
import script from "./BlListField.vue?vue&type=script&lang=js"
export * from "./BlListField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__